import { ChangeEvent } from 'react';

import { Toggle } from 'components/CheckboxToggle/types/Toggle';

export const handleToggleChange = (
  event: ChangeEvent<HTMLInputElement>,
  toggles: Toggle[]
): Toggle[] =>
  toggles.map((toggle) => {
    const toggled = toggle.filter === event.target.name;

    if (toggled) {
      return { ...toggle, active: event.target.checked };
    }
    return toggle;
  });
